import React from 'react'
import C2BenefitsHead from './C2BenefitsHead'
import C2BenefitsMain from './C2BenefitsMain'

const C2Benefits = () => {
  return (
    <div className='lvlBenefitsContainer'>
    <C2BenefitsHead/>
    <C2BenefitsMain/>
  </div>
  )
}

export default C2Benefits
